/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Col_FinishedInputs */

const cs_col_finished = /** @type {(inputs: Col_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokončeno`)
};

const en_col_finished = /** @type {(inputs: Col_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finished`)
};

/**
* | output |
* | --- |
* | "Finished" |
*
* @param {Col_FinishedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const col_finished = /** @type {((inputs?: Col_FinishedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Col_FinishedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_col_finished(inputs)
	return cs_col_finished(inputs)
});